import React, { useCallback } from 'react';

import TTSAudioASRSquare from './TTSAudioASRSquare';
import TTSAudioDTMFSquare from './TTSAudioDTMFSquare';
import SMSSquare from './SMSSquare';
import WebApiListSquare from './WebApiListSquare';
import CommonInputSquare from './CommonInputSquare';
import CommonImageSquare from './CommonImageSquare';

const SquareVoicebot = ({ item, ...props }) => {
  const getVoiceSquareComponent = useCallback((type) => {
    const voiceTypes = {
      VoiceTTSAudioASR: TTSAudioASRSquare,
      VoiceTTSAudioDTMF: TTSAudioDTMFSquare,
      VoiceWebservice: CommonImageSquare,
      VoiceSMS: SMSSquare,
      VoiceWebApiList: WebApiListSquare,
      default: CommonInputSquare,
    };

    return voiceTypes[type] || voiceTypes.default;
  }, []);

  const VoiceSquareComponent = getVoiceSquareComponent(item?.type);

  return <VoiceSquareComponent item={item} {...props} />;
};

export default SquareVoicebot;
